import { render, staticRenderFns } from "./BeenTaked.vue?vue&type=template&id=5a86cc9e&"
import script from "./BeenTaked.vue?vue&type=script&lang=js&"
export * from "./BeenTaked.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports